/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargo_Departure_DateInputs */

const en_cargo_departure_date = /** @type {(inputs: Cargo_Departure_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Departure Date`)
};

const es_cargo_departure_date = /** @type {(inputs: Cargo_Departure_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha de salida`)
};

/**
* | output |
* | --- |
* | "Departure Date" |
*
* @param {Cargo_Departure_DateInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargo_departure_date = /** @type {((inputs?: Cargo_Departure_DateInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargo_Departure_DateInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargo_departure_date(inputs)
	return es_cargo_departure_date(inputs)
});